import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  DashboardError,
  DashboardResponse,
  PayloadParam,
} from '@core/interface/dashboard';

export const DashboardActions = createActionGroup({
  source: 'Dashboard',
  events: {
    'Load Dashboard Data': props<PayloadParam>(),
    'Load Dashboard Data Success': props<DashboardResponse>(),
    'Load Dashboard Data Failure': props<DashboardError>(),
    'Reset Dashboard Data': emptyProps(),
  },
});
